import { Component, Input, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOMenuItem } from "src/app/shared/models/oo-menu-item";
import { OOPriceLevel } from "src/app/shared/models/oo-price-level";

@Component({
	selector: "app-menu-item-price-record",
	templateUrl: "./menu-item-price-record.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class MenuItemPriceRecordComponent implements OnInit {
	@Input() menuItem: OOMenuItem;
	@Input() venueKey: number;
	@Input() priceLevel: OOPriceLevel;

	priceList: any[];

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.priceList = [
			{
				price1: this.menuItem.price,
				price2: this.menuItem.price2,
				price3: this.menuItem.price3,
				price4: this.menuItem.price4,
				price5: this.menuItem.price5,
				price6: this.menuItem.price6,
				price7: this.menuItem.priceSub,
				price8: this.menuItem.priceExtra,
				price9: this.menuItem.priceNo,
				price10: this.menuItem.priceMod,
			},
		];
	}
}
